import React from "react";
import { Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRunning } from "@fortawesome/free-solid-svg-icons";
import { makeStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import { Link } from "react-router-dom";

const Header = () => {
  const useStyles = makeStyles((theme) => ({
    root: {
      margin: "1rem 0",
    },
    inner: {
      marginBottom: '1rem',
    },
    title: {
      color: "#536ade",
    },
    about: {
      textAlign: "right",
    },
    nav: {
      listStyleType: "none",
      padding: 0,
      margin: 0,
    },
  }));

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.inner}>
        <Grid container justify="space-around">
          <Grid item s={9}>
            <Typography variant="h3" className={classes.title}>
              Running Log <FontAwesomeIcon icon={faRunning} />
            </Typography>
          </Grid>
          <Grid item xs={3} className={classes.about}>
              <nav>
              <ul className={classes.nav}>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">React features used...</Link>
                </li>
              </ul>
              </nav>
          </Grid>
        </Grid>
      </div>
      <Divider></Divider>
    </div>
  );
};

export default Header;
